import { render, staticRenderFns } from "./selectCard.vue?vue&type=template&id=23faf083&scoped=true"
import script from "./selectCard.vue?vue&type=script&lang=js"
export * from "./selectCard.vue?vue&type=script&lang=js"
import style0 from "./selectCard.vue?vue&type=style&index=0&id=23faf083&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "23faf083",
  null
  
)

export default component.exports